const SuggestedFieldType = {
  TYPE_NAME: "name",
  TYPE_PHONE: "phone",
  TYPE_EMAIL: "email",
  TYPE_MESSAGE: "message",
};

export default SuggestedFieldType;

export const SuggestedFieldTypeMap = {
  [SuggestedFieldType.TYPE_NAME]: {
    type: "text",
    name: "name",
    label_en: "Name",
    label_fr: "Nom",
    translationKey: "name",
    mandatory: true,
  },
  [SuggestedFieldType.TYPE_PHONE]: {
    type: "text",
    name: "phone",
    label_en: "Phone",
    label_fr: "Téléphone",
    translationKey: "phone",
    mandatory: true,
  },
  [SuggestedFieldType.TYPE_EMAIL]: {
    type: "email",
    name: "email",
    label_en: "Email",
    label_fr: "Courriel",
    translationKey: "email",
    mandatory: true,
  },
  [SuggestedFieldType.TYPE_MESSAGE]: {
    type: "textarea",
    name: "message",
    label_en: "Message",
    label_fr: "Message",
    translationKey: "message",
    mandatory: false,
  },
};
